import type {Mapper} from '@automapper/core';
import type {DownloadColumn, IDownloadByLinkService} from '@igp/shared/api';
import {ServerResponseStatus} from '@igp/shared/api';
import {map} from '@igp/shared/otel';
import type {DownloadStrategyRequest, DownloadStrategyResponse, IDownloadStrategy} from '@igp/shared/redux/download';
import {inject, injectable} from 'inversify';
import type {Observable} from 'rxjs';

import {ServiceTypes} from '@ioc-container';

import {
    PlayerEcologyWeeklyQueryFieldsTypeName,
    PlayerEcologyWeeklyServiceTypes,
    PlayerEcologyWeeklyViewModelKeysTypeName,
} from './constants';
import type {PlayerEcologyWeeklyQueryFields, PlayerEcologyWeeklyViewModelKeys} from './types';

@injectable()
export class PlayerEcologyWeeklyDownloadServerStrategy implements IDownloadStrategy<PlayerEcologyWeeklyViewModelKeys> {
    private readonly _mapper: Mapper;
    private readonly _service: IDownloadByLinkService<PlayerEcologyWeeklyQueryFields>;

    constructor(
        @inject(ServiceTypes.AutoMapper) mapper: Mapper,
        @inject(PlayerEcologyWeeklyServiceTypes.service)
        service: IDownloadByLinkService<PlayerEcologyWeeklyQueryFields>
    ) {
        this._mapper = mapper;
        this._service = service;
    }
    process(
        request: DownloadStrategyRequest<PlayerEcologyWeeklyViewModelKeys>
    ): Observable<DownloadStrategyResponse<PlayerEcologyWeeklyViewModelKeys>> {
        const columns: DownloadColumn<PlayerEcologyWeeklyQueryFields>[] = request.keys?.map<DownloadColumn<PlayerEcologyWeeklyQueryFields>>(
            k => {
                const queryField = this._mapper.map<PlayerEcologyWeeklyViewModelKeys, PlayerEcologyWeeklyQueryFields>(
                    k,
                    PlayerEcologyWeeklyViewModelKeysTypeName,
                    PlayerEcologyWeeklyQueryFieldsTypeName
                );
                return {
                    name: request.headers[k] ?? k,
                    field: queryField,
                };
            }
        );
        return this._service
            .getDownloadLink({
                filter: request.filter,
                columns,
                report_name: request.filename,
            })
            .pipe(
                map(response => ({
                    status: response?.status === ServerResponseStatus.Success ? 'Success' : 'Failed',
                    link: response?.responsePayload,
                    mode: 'server',
                }))
            );
    }
}
